import { render, staticRenderFns } from "./ManageMain.vue?vue&type=template&id=4a581f53&scoped=true&"
import script from "./ManageMain.vue?vue&type=script&lang=js&"
export * from "./ManageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a581f53",
  null
  
)

export default component.exports